import { Component } from "@angular/core";
import { KeyValue } from "@angular/common";
@Component({
  selector: "gh-example-toggle-component",
  templateUrl: "./example-toggle.component.html",
  styleUrls: ["./example-toggle.component.less"],
})
export class ExampleToggleComponent {
  public toggleValue = false;

  public legacyValues: KeyValue<string, boolean> = { key: "test", value: true };

  public doToggle($event: KeyValue<string, boolean>): void {
    this.legacyValues = $event;
  }
}
